// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"d8568528","79":"0e22baa5","142":"00eca03e","407":"046d1822","577":"596fadbe","809":"2dd0b62e","891":"3ab804af"}[chunkId] + ".chunk.css";
};